module.exports = __webpack_public_path__ + "assets/opensans-regular.svg?a9ba7f3d40c0de0e0dc5ad077b047207";